<template>
	<v-app>
		<v-content>
        <div class="px-3 mt-12">
          <div class="mt-4 px-4 text-center">
            <h1 class="body-1 font-weight-bold mb-5">退会完了</h1>
          </div>
          <div class="py-10 text-center">
            <h1 class="body-1">ご利用ありがとうございました。</h1>
          </div>
        </div>
    </v-content>
  </v-app>
</template>

<script>
export default {
  props: [],
  data() {
    return {
    };
  },
}
</script>

<style scoped>
</style>
